export default __webpack_public_path__ + "static/media/Arrow2.3914ac20.svg";